import { useAppSelector } from 'hooks/reduxHooks'
import React, { useContext, useMemo } from 'react'
import CellContent from './CellContent'
import getIsLoyaltyEnabled from 'loyalty/selectors/getIsLoyaltyEnabled'
import { useOfferBestPrice } from 'hooks/Offers/useOfferBestPrice'
import { generateLoyaltyPointsCalculatorBundledFlightOptions, generateLoyaltyPointsCalculatorHotelOptions } from 'loyalty/lib/pointsCalculation/calculatorOptionsGenerators'
import useDefaultAirport from 'hooks/useDefaultAirport'
import LoyaltyPointsEarn from 'loyalty/components/Earn/LoyaltyPointsEarn'
import Group from 'components/utils/Group'
import GeoContext from 'contexts/geoContext'

interface Props {
  offer: App.HotelOffer
  filters: App.OfferListFilters
  packageUniqueKey?: string
}

function LEHotelSearchPriceCell({ offer, filters, packageUniqueKey }: Props) {
  const isLoyaltyEnabled = useAppSelector(getIsLoyaltyEnabled)
  const bestPackage = useOfferBestPrice(offer, filters)
  const selectedPackage = offer.packages.find(p => p.uniqueKey === packageUniqueKey)
  const pkg = selectedPackage ?? bestPackage
  const { currentRegionCode } = useContext(GeoContext)

  const defaultAirport = useDefaultAirport()
  const flightPrice = (offer.flightPrices[defaultAirport?.code ?? ''] || 0)

  const defaultPrice = pkg?.price
  const memberPrice = pkg?.memberPrice ?? 0
  const propertyFees = pkg?.propertyFees ?? 0

  const defaultPriceExcludingPropertyFees = defaultPrice ? defaultPrice - propertyFees : 0
  const memberPriceExcludingPropertyFees = memberPrice ? memberPrice - propertyFees : 0

  const pointsEarnCalculationRequests = useMemo<Array<App.LoyaltyPointsEarnCalculationRequest | undefined>>(() => [
    generateLoyaltyPointsCalculatorHotelOptions(offer, {
      pkg,
      price: defaultPriceExcludingPropertyFees,
      memberPrice: memberPriceExcludingPropertyFees,
      currentRegionCode,
      nights: pkg?.duration,
    }),
    generateLoyaltyPointsCalculatorBundledFlightOptions(offer, {
      flightPrice,
      skip: !offer.bundledWithFlightsOnly,
    }),
  ], [offer, pkg, defaultPriceExcludingPropertyFees, memberPriceExcludingPropertyFees, flightPrice, currentRegionCode])

  if (!isLoyaltyEnabled) {
    return null
  }

  return (
    <CellContent>
      <Group direction="vertical" verticalAlign="center" fullHeight>
        <LoyaltyPointsEarn calculationRequests={pointsEarnCalculationRequests} calculationType="estimate" />
      </Group>
    </CellContent>
  )
}

export default LEHotelSearchPriceCell
